export default __webpack_public_path__ + "static/media/fire.8b680855.svg";